import { IPaginationData } from '@/common/interfaces/index.interface';
import LocalStorageHelper from '@/helpers/LocalStorageHelper';
import { TEnvironmentName } from '@/common/types/index.types';
import config from '../../config';

interface IEnumItem<E> {
  id: E;
  name: keyof E;
}

export default class AppHelper {
  public static deepClone<T>(object: T): T {
    return JSON.parse(JSON.stringify(object));
  }

  public static enumToArray<E>(enumToConvert: Record<string, unknown>): IEnumItem<E>[] {
    return Object.keys(enumToConvert).map(key => ({ id: enumToConvert[key], name: key } as IEnumItem<E>));
  }

  public static partnerShopLink(link: string): string {
    const partnerShopSubdomain = LocalStorageHelper.getPartnerShopInformation()?.subdomain;
    return link.replace(`partnersite`, partnerShopSubdomain ?? `www`);
  }

  public static redirectFromPPS(): void {
    const domain = document.location.href;
    document.location.href = `https://www${domain.substr(domain.indexOf(`.`))}`;
  }

  public static getEnvironmentName(): TEnvironmentName {
    const envNameRegex = new RegExp(`(ringana+(-[A-Za-z0-9]+)?)`);
    const rawEnvName = envNameRegex.exec(config.api.baseurl)?.[0] ?? `ringana-development`;
    const envName = rawEnvName.substring(rawEnvName.indexOf(`-`) + 1);
    return envName === `ringana` ? `production` : (envName as TEnvironmentName);
  }

  public static openLink(url: string, target = `_self`): void {
    const win = window.open(url, target);
    if(win) {
      win.focus();
    }
  }

  public static isIndexInPaginationRange(index: number, paginationData: IPaginationData): boolean {
    const afterFirstEntryInTable = index >= paginationData.start;
    const beforeLastEntryInTable = index < (paginationData.start + paginationData.perPage);
    return !(afterFirstEntryInTable && beforeLastEntryInTable);
  }
}
